import React, { useCallback,useState, useEffect } from "react";
import { connect } from "react-redux";
import FileSaver from "file-saver";
import * as R from 'ramda';
import { useCurrentPng } from "recharts-to-png";
import { bindActionCreators } from "redux";
import Groups from "../../ducks/Groups";
import Reports from "../../ducks/Reports";
import Things from "../../ducks/Things";
import Visualization from "../../ducks/Visualization";
import Select from "react-select-nested-group";
import CheckboxListComponent from "../../components/common/CheckboxListComponent";
import * as _ from "lodash";
import classnames from "classnames";
import { validateInput } from "../../validations/violationBar";
import { WhiteSpinner } from "../common/Spinner/index";
import {
  BarChart,
  XAxis,
  YAxis,
  Bar,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import DateTime from "react-datetime";
import {
  Card,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import moment from "moment";
import placeholder from "../../assets/img/chart-placeholder.svg";
const ViolationBarChart = (props) => {
  let userData = JSON.parse(localStorage.getItem("user"));
  let userGroups = userData['user']['group'];
  let childGroup=[];
  if (userGroups['child']){
    childGroup = userGroups['child'];
    childGroup.unshift(userGroups);
  }

  const [activeTab, setActiveTab] = useState("devices");
  const [state, setState] = useState({
    selectedDevices: [],
    errors: {},
    selectAll: false,
    userGroups:childGroup,
    selectedGroups:{ value: userGroups._id, label: userGroups.name || "N/A", item: userGroups},
    loader: false,
    violations: [
      {
        id: "LOW_TEMPERATURE_DETECTED",
        name: "LOW TEMPERATURE DETECTED",
      },
      {
        id: "LOW_HUMIDITY_DETECTED",
        name: "LOW HUMIDITY DETECTED",
      },
      {
        id: "HIGH_TEMPERATURE_DETECTED",
        name: "HIGH TEMPERATURE DETECTED",
      },
      {
        id: "HIGH_HUMIDITY_DETECTED",
        name: "HIGH HUMIDITY DETECTED",
      }
    ],
    selectedViolations: [],
    startDate: moment().subtract("1", "days"),
    endDate: moment(),
    data: [],
  });
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [getViolationsPng, { ref: violationsRef }] = useCurrentPng();
  const [eventName, setEventName] = useState('')
  useEffect(() => {
      (async() => {
        let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
        await props.actions.getGroupVehicles({ groupId:  companyInfo?.groupId });
      })();
  }, []);
  useEffect(() => {
    setState({
      ...state,
      devices: props.things,
    });
  }, [props.things]);

  const handleViolationsDownload = useCallback(async () => {
    const png = await getViolationsPng();
    if (png) {
      FileSaver.saveAs(png, "violations-chart.png");
    }
  }, [getViolationsPng]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const isTabActive = (name) => {
    return name === activeTab;
  };
  const searchDevices = (e) => {
    const value = e.target.value;
    let devices = [];

    let selectedDevices = state.selectedDevices;
    if (value) {
      _.forEach(props.things, (item) => {
        if (item.imei.search(new RegExp(value, "i")) >= 0) {
          let index = selectedDevices.findIndex((obj) => {
            return obj === item._id;
          });

          devices.push({
            _id: item._id,
            imei: item.imei || "N/A",
            checked: index > -1 ? true : false,
          });
        }
      });
    } else {
      devices = _.map(props.things, (item) => {
        let index = selectedDevices.findIndex((obj) => {
          return obj === item._id;
        });
        return {
          _id: item._id,
          imei: item.imei || "N/A",
          checked: index > -1 ? true : false,
        };
      });
    }
    setState({
      ...state,
      devices,
    });
  };
  const checkBoxListChanged = (value) => {
    let devices = state.devices;
    let selectedDevices = state.selectedDevices;
    let isSelectAll = state.selectAll;

    if (devices.length > 0) {

      for (let i = 0; i < devices.length; i++) {
        let item = devices[i];
        if (i === parseInt(value, 10)) {
          item.checked = !item.checked;
          devices[i] = item;
          if (item.checked) {
            selectedDevices.push(item._id);
          } else {
            let index = selectedDevices.findIndex((obj) => {
              return obj === item._id;
            });
            if (index > -1) {
              if (isSelectAll) isSelectAll = false;
              selectedDevices.splice(index, 1);
            }
          }
        }
      }
    }

    setState({
      ...state,
      devices,
      selectedDevices,
      selectAll: isSelectAll
    });
  };
  const checkViolationChanged = (value) => {
    setState({
      ...state,
      selectedViolations: value,
    });
  };

  const handleGroupChange = async (value) => {
    setState({
      ...state,
      selectedGroups: value,
    });
    await props.actions.getGroupVehicles({ groupId:  value.value });
  }
  const onChangeStartDate = (e) => {
    setState({ ...state, startDate: new Date(e) });
  };
  const onChangeEndDate = (e) => {
    setState({ ...state, endDate: new Date(e) });
  };
  const isValid = () => {
    const { errors, isValid } = validateInput(state);
    if (!isValid) {
      setState({ ...state, errors });
    }
    return isValid;
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (state.loader) {
      return;
    }
    if (isValid()) {
      delete state.errors;
      setState({
        ...state,
        loader: true,
      });
      const requestObject = {
        devices: state.selectedDevices,
        violations: state.selectedViolations.map((sv) => sv.value),
        startDate: state.startDate.toISOString(),
        endDate: state.endDate.toISOString(),
      };
      //call api
      await props.chartActions.loadViolationChartData(requestObject);
      setState({
        ...state,
        loader: false,
      });
    }
  };

  const checkBoxListSelectAll = async (e) => {

    let devices = state.devices,
    selectedDevices = state.selectedDevices,
      isSelectAll = state.selectAll;

    if (devices.length > 0) {
      for (let i = 0; i < devices.length; i++) {
        let item = devices[i];
        if (!isSelectAll) {
          item.checked = true;
          selectedDevices.push(item._id);
        }
        else {
          item.checked = false;
          let index = selectedDevices.findIndex(obj => obj === item._id);
          if (index > -1) selectedDevices.splice(index, 1);
        }
        devices[i] = item;
      }
    }
    setState({ ...state, devices, selectedDevices, selectAll: !isSelectAll });
  };

  const showModal = (event, eventName) => {
    setModalData(props.violation.count[event].events || [])
    setModal(true);
    setEventName(eventName);
  };
  const toggle = () => setModal(!modal);
  const loader = <WhiteSpinner key="1" />;
  return (
    <>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{`${eventName} Violation Details`}</ModalHeader>
        <ModalBody>
          <table className='table-auxo'>
            <thead>
              <tr>
              <th>Plate Number</th>
              <th>Group</th>
              <th>Violation Time</th>
              <th>Location</th>
              </tr>
            </thead>
            <tbody>
              {modalData.map((row, index) => {
                return (
                  <tr key={index.toString()}>
                    <td className="modal-cell">{row.thingId.plateNumber}</td>
                    <td className="modal-cell">{row.thingId.group.name}</td>
                    <td className="modal-cell">{moment(row.eventTime).format("DD-MMM-YYYY hh:mm a")}</td>
                    <td className="modal-cell"><a href={`https://google.com/maps/search/${row.thing.state.latlng}`} target="_blank" rel="noopener noreferrer">{row.location}</a></td>
                  </tr>
                )
              })}
              {
                modalData.length === 0 && <tr>
                  <td colSpan="4" style={{textAlign: "center"}}>
                    No Violations found.
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </ModalBody>
        <ModalFooter>
          <button className="btn auxo-primary-btn create-geofence-btn" onClick={toggle}>Close</button>
        </ModalFooter>
      </Modal>
      <div className="row">
        <div className="col-md-4">
          <form onSubmit={onSubmit}>
            <Card className="height-100-p " style={{ minWidth: "100%" }}>
              <CardHeader className="f-bold">Filter Criteria</CardHeader>
              <div className="col p-10-px">
              <div className="form-group">
                  <label>Select Group</label>
                  <Select
                    name="form-field-name"
                    isClearable={true}
                    isSearchable={true}
                    placeholder="Search"
                    onChange={handleGroupChange}
                    value={state.selectedGroups}
                    options={
                      state.userGroups &&
                      state.userGroups.map((item) => ({
                        value: item._id,
                        label: item.name || "N/A",
                        item: item,
                      }))
                    }
                  />
                </div>
                {state.errors && (
                  <span className="text-danger">{state.errors.groups}</span>
                )}
                <div className="form-group">
                  <label>Select Violation</label>
                  <Select
                    name="form-field-name"
                    isClearable={true}
                    isMulti
                    isSearchable={true}
                    placeholder="Search"
                    onChange={checkViolationChanged}
                    value={state.selectedViolations}
                    options={
                      state.violations &&
                      state.violations.map((item) => ({
                        value: item.id,
                        label: item.name || "N/A",
                        item: item,
                      }))
                    }
                  />
                </div>
                {state.errors && (
                  <span className="text-danger">{state.errors.violations}</span>
                )}
                <div className="form-group">
                  <label>Start Date</label>
                  <DateTime
                    value={state.startDate}
                    dateFormat="DD-MM-YYYY"
                    timeFormat={false}
                    onChange={onChangeStartDate}
                  />
                </div>
                {state.errors && (
                  <span className="text-danger">{state.errors.startDate}</span>
                )}
                <div className="form-group">
                  <label>End Date</label>
                  <DateTime
                    value={state.endDate}
                    dateFormat="DD-MM-YYYY"
                    timeFormat={false}
                    onChange={onChangeEndDate}
                  />
                </div>
                {state.errors && (
                  <span className="text-danger">{state.errors.endDate}</span>
                )}

                <label>Select Devices</label>
                <ul className="nav nav-tabs" role="tablist">
                  <li className="nav-item">
                    <a
                      className={"nav-link active"}
                      onClick={() => handleTabClick("devices")}
                    >
                      Devices
                    </a>
                  </li>
                </ul>
                <div className="tab-content access-tab mb-5 heading-200">
                  <div
                    className={classnames("tab-pane fade", {
                      "show active": isTabActive("devices"),
                    })}
                  >
                    <CheckboxListComponent
                     selectAllCheck={state.selectAll}
                     selectAllEnabled={!!state?.devices?.length}
                     selectAll={checkBoxListSelectAll}
                      enableSearch="true"
                      search={searchDevices}
                      onChange={checkBoxListChanged}
                      data={
                        state.devices &&
                        state.devices.map((item) => ({
                          mainTitle: item.name || "N/A",
                          checked: item.checked,
                        }))
                      }
                    />
                  </div>
                </div>
                {state.errors && (
                  <span className="text-danger">{state.errors.devices}</span>
                )}

                <div className="margin-btm-50">
                  <button
                    className="btn auxo-primary-btn create-geofence-btn"
                    type="submit"
                  >
                    {state.loader ? [loader] : "Filter"}
                  </button>
                </div>
              </div>
            </Card>
          </form>
        </div>
        <div className="col-md-8">
          <Card className="height-100-p" style={{ minWidth: "100%" }}>
            <CardHeader className="f-bold">
              Visualization
              {props.violation?.data?.length > 0 && (
                <span>
                  <button
                    className="btn auxo-primary-btn m-btn-v"
                    type="button"
                    onClick={() => handleViolationsDownload()}
                  >
                    <i className="fa fa-download"></i>
                  </button>
                </span>
              )}
            </CardHeader>
            {props.violation?.data?.length > 0 && (
              <div className="row" style={{ margin: "11px 0px 1px 0px" }}>
                <div className="col-md-2 offset-md-1 col-sm-6">
                  <div className="stat-card card-hover">
                    <span className="counter">
                      {props.violation.count?.LOW_TEMPERATURE_DETECTED?.total || 0}
                    </span>
                    <p className="f-11-px text-center">LOW TEMPERATURE</p>
                  </div>
                </div>
                <div className="col-md-2 col-sm-6">
                  <div className="stat-card card-hover">
                    <span className="counter">
                      {props.violation?.count?.LOW_HUMIDITY_DETECTED?.total || 0}
                    </span>
                    <p className="f-11-px text-center">LOW HUMIDITY</p>
                  </div>
                </div>
                <div className="col-md-2 col-sm-6">
                  <div className="stat-card card-hover">
                    <span className="counter">
                      {props.violation?.count?.HIGH_TEMPERATURE_DETECTED?.total || 0}
                    </span>
                    <p className="f-11-px text-center">HIGH TEMPERATURE</p>
                  </div>
                </div>
                <div className="col-md-2 col-sm-6">
                  <div className="stat-card card-hover">
                    <span className="counter">
                      {props.violation?.count?.HIGH_HUMIDITY_DETECTED?.total || 0}
                    </span>
                    <p className="f-11-px text-center">HIGH HUMIDITY</p>
                  </div>
                </div>
              </div>
            )}

            {props.violation?.data?.length > 0 && (
              <ResponsiveContainer
                width="98%"
                height="60%"
                className="m-t-40-px"
              >
                <BarChart  ref={violationsRef} data={props.violation?.data} width={700} height={300}>
                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="plateNumber" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="LowTemperature" fill="#FF0000" />
                  <Bar dataKey="LowHumidity" fill="#FFA500" />
                  <Bar dataKey="HighTemperature" fill="#03ABCE" />
                  <Bar dataKey="HighHumidity" fill="#FA8072" />
                </BarChart>
              </ResponsiveContainer>
            )}
            {props.violation?.data?.length === 0 && (
              <div className="img-container">
                <img src={placeholder} width="600" height="400" />
              </div>
            )}
          </Card>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  things: state.things.groupVehicles,
  violation: state.visualization.violationChartData,
});
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Things.creators, dispatch),
  // actions: bindActionCreators(Groups.creators, dispatch),
  chartActions: bindActionCreators(Visualization.creators, dispatch),
  reportActions: bindActionCreators(Reports.creators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViolationBarChart);
